import React, { Component } from "react"
import Link from "gatsby-link"
import logo from "../assets/logo.svg"
import styled from "styled-components"
import {
  SMALLCHAT_SHADOW,
  PRIMARY_TEXT,
  SMALLCHAT_PURPLE
} from "../components/consts/colors"

const Container = styled.nav`
  z-index: 9001;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: white;
  @media (max-width: 480px) {
    position: absolute;
  }
`

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Brand = styled.div``

const Logo = styled.img`
  margin-top: 4px;
  height: 32px;
  @media (max-width: 768px) {
    margin-top: 10px;
    height: 24px;
  }
`

const PagesList = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: baseline;
  list-style-type: none;
  li {
    display: flex;
    align-items: center;
    height: 60px;
    margin-left: 30px;
    .PageLink {
      display: block;
      line-height: 24px;
      border-bottom: 2px solid transparent;
    }
    .PageLink:hover,
    .PageLink-active {
      color: ${PRIMARY_TEXT};
      border-bottom-color: ${PRIMARY_TEXT};
    }
  }
  @media (max-width: 768px) {
    overflow: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    background-color: white;
    height: ${props => (props.expand ? 50 * 4 : 0)}px;
    transition: height ${props => (props.expand ? 100 : 0)}ms ease-out;
    li {
      height: 50px
      margin-left: 20px;
    }
  }
`

const Button = styled.a`
  display: block;
  padding: 5px 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  transition: all 150ms;
  cursor: pointer;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  }
`

const MenuButton = styled(Button)`
  @media (min-width: 769px) {
    display: none;
  }
`

function PageLink(props) {
  return (
    <Link {...props} className="PageLink" activeClassName="PageLink-active" />
  )
}

class Nav extends Component {
  state = {
    expand: false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState({ expand: false })
    }
  }

  toggleMenu = () => {
    this.setState({ expand: !this.state.expand })
  }

  render() {
    return (
      <Container>
        <Wrapper>
          <Brand>
            <Link to="/">
              <Logo src={logo} />
            </Link>
          </Brand>
          <PagesList expand={this.state.expand}>
            <li>
              <PageLink to="/pricing">Pricing</PageLink>
            </li>
            <li>
              <PageLink to="/features">Features</PageLink>
            </li>
            <li>
              <a className="PageLink" href="https://docs.small.chat/">
                Docs
              </a>
            </li>
            <li>
              <Button href="https://my.small.chat/">Login</Button>
            </li>
          </PagesList>
          <MenuButton onClick={this.toggleMenu}>Menu</MenuButton>
        </Wrapper>
      </Container>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/layouts/Nav.js